<form [formGroup]="newContractForm">
    <div class="container">
        <h2 class="mat-title">Création d'un contrat</h2>

        <div class="light-blue-horizontal-separator"></div>

        <div class="loaded-content-container" *ngIf="!isLoadingAdvertisers; else loading">
            <div class="bloc-container">
                <h4 class="red-title">Informations Générales</h4>

                <!-- Advertiser -->
                <div class="tv-rect-input-extensible full-width">
                    <mat-form-field>
                        <mat-label class="content-position">Choix de l'annonceur</mat-label>
                        <input matInput formControlName="advertiser" [matAutocomplete]="autoAdvertiser" />
                        <mat-error class="error" *ngIf="newContractForm.get('advertiser')?.hasError('required')">
                            Veuillez choisir un annonceur
                        </mat-error>
                        <mat-autocomplete
                            autoActiveFirstOption
                            class="tv-custom-always-visible-scroll-bar"
                            #autoAdvertiser="matAutocomplete"
                            [displayWith]="displayAutoCompleteData">
                            <mat-option
                                *ngFor="let advertiser of filteredAdvertiserList | async"
                                class="tv-ns-select-option"
                                [value]="advertiser">
                                {{ advertiser.name }} - {{ advertiser.id }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <!-- 2nd Row -->
                <div class="inputs-bloc-container">
                    <!-- Contract Type -->
                    <div class="tv-container-select-white-rect-extensible two-thirds-width">
                        <mat-form-field>
                            <mat-label class="content-position">Type de contrat</mat-label>
                            <mat-select panelClass="tv-custom-always-visible-scroll-bar" formControlName="contractCgvType">
                                <mat-option
                                    *ngFor="let contractCgvType of contractCgvTypeList"
                                    class="tv-ns-select-option"
                                    [value]="contractCgvType">
                                    {{ contractCgvType.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="error" *ngIf="newContractForm.get('contractCgvType')?.hasError('required')">
                                Veuillez choisir un type de contrat
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Year -->
                    <div class="tv-container-select-white-rect-extensible one-third-width">
                        <mat-form-field>
                            <mat-label class="content-position">Année du contrat</mat-label>
                            <mat-select panelClass="tv-custom-always-visible-scroll-bar" formControlName="year">
                                <mat-option *ngFor="let year of yearList" class="tv-ns-select-option" [value]="year">
                                    {{ year }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="error" *ngIf="newContractForm.get('year')?.hasError('required')">
                                Veuillez choisir une année
                            </mat-error>
                            <mat-error *ngIf="newContractForm.get('year')?.hasError('required')"></mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="button-edit">
                <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler</button>
                <button type="submit" class="tv-ns-validation-large-button" (click)="onValidationButtonClick()">Valider</button>
            </div>
        </div>
        <ng-template #loading>
            <div class="spinner">
                <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
            </div>
        </ng-template>
    </div>
</form>
